import clsx from 'clsx';
import type { IconType } from '@seeqdev/qomponents';
import { Icon } from '@seeqdev/qomponents';

export interface IconWithSpinnerProps {
  id?: string;
  icon?: string;
  spinning: boolean;
  large?: boolean;
  white?: boolean;
  type?: IconType;
  extraClassNames?: string;
  testId?: string;
  customId?: string;
  correctSpin?: boolean;
  disabled?: boolean;
}

/** Icon that switches to spinner when input parameter is true */
export const IconWithSpinner: React.FunctionComponent<IconWithSpinnerProps> = ({
  id,
  spinning,
  icon = '',
  large,
  white,
  extraClassNames,
  testId,
  customId,
  correctSpin = true,
  disabled = false,
  type = 'theme',
}) => {
  const spinningIconClasses = clsx('fa-solid', 'fa-spinner', 'fa-spin-pulse', { correctSpin });

  return (
    <Icon
      id={id}
      testId={testId}
      customId={customId}
      iconPrefix={spinning ? spinningIconClasses : undefined}
      type={white ? 'white' : type}
      icon={spinning ? '' : icon}
      large={large}
      extraClassNames={clsx(extraClassNames, {
        'disabledLook cursorNotAllowed': disabled,
      })}
    />
  );
};
